// Copied from rakerone-web/src/components/code/themes.ts.
import pierreDarkSoft from '@pierre/theme/pierre-dark-soft'
import pierreLightSoft from '@pierre/theme/pierre-light-soft'

import type { ThemeRegistrationRaw } from 'shiki/core'

export const lightTheme = pierreLightSoft as unknown as ThemeRegistrationRaw
export const darkTheme = pierreDarkSoft as unknown as ThemeRegistrationRaw
export const LIGHT_THEME = pierreLightSoft.name
export const DARK_THEME = pierreDarkSoft.name

/** CloudRaker's dark raised separator surface; swapped inside Shiki's output too. */
export const DARK_THEME_BACKGROUND = '#26262e'
const PIERRE_DARK_BACKGROUND =
  (pierreDarkSoft.colors?.['editor.background'] as string | undefined) ?? '#171717'
export const DARK_COLOR_REPLACEMENTS: Record<string, string> = {
  [PIERRE_DARK_BACKGROUND.toLowerCase()]: DARK_THEME_BACKGROUND,
  [PIERRE_DARK_BACKGROUND.toUpperCase()]: DARK_THEME_BACKGROUND,
}
